import { styled } from "@material-ui/core";

export const NewFooter = styled("div")(({ theme }) => ({
  paddingTop: theme.spacing(2),
  display: "flex",
  justifyContent: "flex-end",
}));
